__turbopack_context__.v({
  "centered": "style-module__crqPRW__centered",
  "feature": "style-module__crqPRW__feature",
  "features": "style-module__crqPRW__features",
  "large": "style-module__crqPRW__large",
  "light-only": "style-module__crqPRW__light-only",
  "link": "style-module__crqPRW__link",
});
